module.exports = __webpack_public_path__ + "49b194146b04e42d073cd4f61410a287.fbx";